
import React from "react";
import { Row, Col } from "reactstrap";
import { browserName, browserVersion } from "react-device-detect";
import SpeakAudioTest from "../../components/audioVisualizer/SpeakIndex";
import { AudioUrl } from "../../libs/env";
import { EuroNetWorkSpeedTest } from "../../components/EuroNetWorkSpeedTest/EuroNetWorkSpeedTest";
import { EuroBrowserCompatibility } from "../../components/EuroBrowserCompatibility/EuroBrowserCompatibility";
const EuroSystemModal = ({ data, assessmentStarted, toggle }) => {
  return (
    <div>
      <div className={`px-4 col-12 py-0`}>
        <div className="d-flex align-items-start">
          <span className="bold-Text ">
            Check your system settings
          </span>
          {(data?.status === "In progress" || assessmentStarted) && (
            <button
              onClick={() => {
                toggle();
              }}
              className="btn p-0 float-end"
            >
              <svg
                width="14"
                height="14"
                viewBox="0 0 14 14"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M13 1L1 13M1 1L13 13"
                  stroke="#A4A7AE"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </button>
          )}
        </div>
        <div className="col-12 d-flex mt-2 pt-1 mb-3">
          <div className="d-flex px-2 col-10 py-1 semiBoldText rounded-5">
            <div>
              <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clip-path="url(#clip0_2884_4080)">
                  <path
                    d="M8.00065 5.33325V7.99992M8.00065 10.6666H8.00732M14.6673 7.99992C14.6673 11.6818 11.6826 14.6666 8.00065 14.6666C4.31875 14.6666 1.33398 11.6818 1.33398 7.99992C1.33398 4.31802 4.31875 1.33325 8.00065 1.33325C11.6826 1.33325 14.6673 4.31802 14.6673 7.99992Z"
                    stroke="#6C727F"
                    stroke-width="1.41667"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_2884_4080">
                    <rect width="16" height="16" fill="white" />
                  </clipPath>
                </defs>
              </svg>
            </div>
            <div>
              <span className="p-1 mt-2">
                Ensure you are in a quiet environment.
              </span>
            </div>
          </div>
        </div>
        <span className="boldText">
          Play the recording to test your speakers.
        </span>
        <Row className={`mt-3`}>
          <Col className="">
            <audio
              className="audio-size"
              controls
              controlsList="noplaybackrate nodownload"
            >
              <source src={`${AudioUrl}/audio_test.mp3`} />
            </audio>
          </Col>
        </Row>
        <EuroNetWorkSpeedTest requirementdata="system requirement" />
        <EuroBrowserCompatibility
          browserName={browserName}
          browserVersion={browserVersion}
        />
      </div>
    </div>
  );
};

export default EuroSystemModal;
